import axios from '../utils/axios'

export const uploadFile = async (file: any) => {
    try {
        const {data} = await axios.post('files/upload', file, {headers: {'Content-type': 'multipart/form-data'}});
        return data;
    } catch (error) {
        throw error;
    }
}

export const downloadFile = async (fileId: number) => {
    try {
        window.open(`${import.meta.env.VITE_API_BASE_URL}files/download/${fileId}`);
    } catch (error) {
        throw error;
    }
}